import mutations from './mutationsShared';

const TimeTrackingStore = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {},
  mutations,
};

export default TimeTrackingStore;
